import { render, staticRenderFns } from "./tabPage.vue?vue&type=template&id=765ad51d&"
import script from "./tabPage.vue?vue&type=script&lang=js&"
export * from "./tabPage.vue?vue&type=script&lang=js&"
import style0 from "./tabPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports